export const HOUSING_INCOME_ROWS = [
  {
    category: "HIS-1",
    meaning: "Habitação de Interesse Social 1",
    familyIncome: "R$ 4.863,00/mês",
    perCapitaIncome: "R$ 810,50/mês",
    rentLimit: "R$ 1.458,90/mês",
  },
  {
    category: "HIS-2",
    meaning: "Habitação de Interesse Social 2",
    familyIncome: "R$ 9.726,00/mês",
    perCapitaIncome: "R$ 1.621,00/mês",
    rentLimit: "R$ 2.917,80/mês",
  },
  {
    category: "HMP",
    meaning: "Habitação de Mercado Popular",
    familyIncome: "R$ 16.210,00/mês",
    perCapitaIncome: "R$ 2.431,50/mês",
    rentLimit: "R$ 4.863,00/mês",
  },
] as const;

export const RENTAL_CHECKLIST = [
  "classificação da unidade",
  "faixa de renda aplicável",
  "renda familiar do futuro locatário",
  "documentação comprobatória",
  "valor de locação permitido",
  "regras específicas do empreendimento e da unidade",
];

export const RENTAL_STEPS = [
  {
    title: "Identificamos a categoria da unidade",
    body: "Primeiro é necessário saber se o imóvel é HIS-1, HIS-2, HMP ou uma unidade residencial convencional.",
  },
  {
    title: "Verificamos o enquadramento do interessado",
    body: "A renda familiar e, quando aplicável, a renda per capita são verificadas conforme os limites vigentes.",
  },
  {
    title: "Analisamos a documentação",
    body: "Os documentos necessários são utilizados para comprovação das informações do futuro locatário e para o processo normal de locação.",
  },
  {
    title: "Validamos as condições da locação",
    body: "O valor e as condições da locação precisam respeitar a regulamentação aplicável à unidade.",
  },
  {
    title: "Formalizamos a locação",
    body: "Com o enquadramento validado e a documentação aprovada, seguimos para contrato e conclusão da locação.",
  },
];

export const OWNER_PILLARS = [
  {
    title: "Enquadramento",
    body: "Buscamos locatários compatíveis com a categoria da unidade.",
  },
  {
    title: "Distribuição",
    body: "Divulgamos o imóvel nos canais adequados para gerar demanda.",
  },
  {
    title: "Validação",
    body: "Conduzimos as etapas necessárias antes da formalização da locação.",
  },
  {
    title: "Gestão",
    body: "Acompanhamos a jornada de locação e administração do imóvel.",
  },
];

export const HOUSING_COMPARISON_ROWS = [
  ["Público definido por renda", "Sim", "Normalmente não"],
  ["Comprovação de enquadramento", "Sim", "Não pelo regime HIS/HMP"],
  ["Limite específico de aluguel", "Sim", "Não"],
  ["Curta temporada", "Vedada atualmente", "Depende da legislação e das regras do condomínio"],
  ["Regras específicas de comercialização", "Sim", "Regras gerais de mercado"],
  ["Necessidade de conhecer a classificação", "Fundamental", "Não se aplica da mesma forma"],
];

export const HOUSING_MISTAKES = [
  {
    myth: "Todo apartamento pequeno é HIS.",
    fact: "Não. A classificação depende do enquadramento urbanístico da unidade.",
  },
  {
    myth: "Se eu sou proprietário, posso alugar para qualquer pessoa.",
    fact: "Não necessariamente. Durante o período sujeito às regras, é preciso respeitar o público compatível com a classificação.",
  },
  {
    myth: "HIS não pode ser alugado.",
    fact: "Pode, desde que sejam cumpridas as regras.",
  },
  {
    myth: "Posso usar HMP no Airbnb.",
    fact: "Atualmente, não. A curta temporada é vedada nas unidades HIS e HMP em São Paulo.",
  },
  {
    myth: "Depois que comprei, deixa de ser HIS/HMP.",
    fact: "Não. A compra por si só não elimina as obrigações vinculadas à classificação da unidade.",
  },
];

export const HOUSING_FAQS = [
  {
    question: "O que é HIS?",
    answer:
      "HIS significa Habitação de Interesse Social. Em São Paulo, a categoria é destinada a famílias de menor renda e é dividida em HIS-1 e HIS-2.",
  },
  {
    question: "O que é HMP?",
    answer:
      "HMP significa Habitação de Mercado Popular e atende famílias dentro de uma faixa de renda mais ampla que a HIS.",
  },
  {
    question: "Qual é a renda máxima para HIS em 2026?",
    answer:
      "Em 2026, a renda familiar mensal máxima é de R$ 4.863,00 para HIS-1 e R$ 9.726,00 para HIS-2, observados também os critérios de renda per capita previstos na regulamentação.",
  },
  {
    question: "Qual a renda máxima para HMP em 2026?",
    answer:
      "O limite de renda familiar mensal estabelecido para HMP em 2026 é de R$ 16.210,00, além do critério de renda per capita aplicável.",
  },
  {
    question: "Posso alugar um imóvel HIS?",
    answer:
      "Sim. O imóvel pode ser alugado desde que sejam cumpridos os critérios definidos para a categoria, incluindo o enquadramento do locatário.",
  },
  {
    question: "Posso alugar um imóvel HMP?",
    answer:
      "Sim. Assim como na HIS, é necessário respeitar as regras aplicáveis à unidade e à renda do locatário.",
  },
  {
    question: "Existe valor máximo de aluguel para HIS e HMP?",
    answer:
      "Sim. A regulamentação municipal estabelece limite de locação equivalente a 30% da renda familiar máxima definida para a respectiva tipologia.",
  },
  {
    question: "Posso fazer Airbnb em imóvel HIS?",
    answer:
      "Não. Atualmente a locação de curta temporada é proibida para unidades HIS e HMP no Município de São Paulo.",
  },
  {
    question: "Quem fiscaliza imóveis HIS e HMP?",
    answer:
      "A Prefeitura de São Paulo possui mecanismos de fiscalização e pode utilizar análise documental, dados, anúncios e outras formas de controle para verificar a correta destinação das unidades.",
  },
  {
    question: "Como saber se meu apartamento é HIS ou HMP?",
    answer:
      "É necessário verificar a documentação e o enquadramento oficial da unidade e do empreendimento. A classificação não deve ser presumida apenas pela metragem, preço ou localização.",
  },
  {
    question: "A 7 Cantos aluga imóveis HIS e HMP?",
    answer:
      "Sim. A 7 Cantos atua com locação de imóveis HIS e HMP e pode auxiliar tanto proprietários que possuem unidades dessas categorias quanto pessoas procurando um imóvel compatível com sua renda.",
  },
  {
    question: "Quanto tempo um imóvel permanece com as restrições de HIS/HMP?",
    answer:
      "A legislação atual estabelece regras de destinação durante o período de 10 anos contado conforme o marco aplicável à unidade, como primeira comercialização ou emissão do Habite-se.",
  },
];

export const HOUSING_SOURCES = [
  {
    label: "Plano Diretor Estratégico de São Paulo — Lei Municipal nº 16.050/2014",
    href: "https://www.prefeitura.sp.gov.br/cidade/secretarias/urbanismo/legislacao/planos_diretores/index.php?p=8264",
  },
  {
    label: "Decreto Municipal nº 63.130/2024",
    href: "https://legislacao.prefeitura.sp.gov.br/leis/decreto-63130-2024",
  },
  {
    label: "Decreto Municipal nº 64.244/2025",
    href: "https://legislacao.prefeitura.sp.gov.br/leis/decreto-64244-2025",
  },
  {
    label: "Decreto Municipal nº 64.895/2026",
    href: "https://legislacao.prefeitura.sp.gov.br/leis/decreto-64895-2026",
  },
  {
    label: "Secretaria Municipal de Habitação de São Paulo — informações sobre HIS e HMP",
    href: "https://www.prefeitura.sp.gov.br/cidade/secretarias/habitacao/",
  },
];
